import Router from "./Router";
import { BrowserRouter } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import { ThemeProvider } from "./theme/ThemeProvider";
const GlobalStyle = createGlobalStyle`
    body {
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
    }
`;

function App() {
    return (
    <ThemeProvider>
        <BrowserRouter>
            <GlobalStyle />
            <Router />
        </BrowserRouter>
    </ThemeProvider>);
}

export default App;